import type { BrowserOptions } from '@sentry/nextjs';
import { AppEnv } from 'utils/accessEnviroment';

export const sentryClientConfig: BrowserOptions = {
  dsn: AppEnv.SENTRY_DSN,
  tracesSampleRate: 1,
  environment: AppEnv.ENV,
  release: '1.0.0'
};
